export default __webpack_public_path__ + "static/media/HorizonMediaLogo.4a16e1c6.png";